import { Navigate } from "react-router-dom";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { useAuth } from "@/contexts/AuthContext";
import { LaunchScreen } from "@/components/loading/LaunchScreen";

/**
 * Restricts a route to admins only. Non-admins are redirected to a
 * safe public fallback (default: /faq). Used to retire beta-only
 * surfaces from the public app while keeping the underlying content
 * available to admins.
 */
export const AdminOnlyRoute = ({
  children,
  redirectTo = "/faq",
}: {
  children: React.ReactNode;
  redirectTo?: string;
}) => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, loading } = useAdminStatus();

  // Wait for the auth session to hydrate before deciding. After clearing
  // site data the Supabase session restores asynchronously; checking too
  // early made admins bounce to /faq.
  if (authLoading || (user && loading)) return <LaunchScreen />;
  if (loading) return <LaunchScreen />;
  if (!isAdmin) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
};